import React from 'react';

const TEST_USERS = ['陈晴曦', '景崎', '姚悦琪'];

export default function AlumniList({ users, currentUser, classmates }) {
  const others = users.filter(u => u.id !== currentUser?.id && !TEST_USERS.includes(u.name));

  if (others.length === 0) {
    return <div style={{ color: '#999', padding: 20, textAlign: 'center' }}>暂无其他校友，邀请同学来加入吧！</div>;
  }

  const grouped = {};
  others.forEach(u => {
    const key = u.schoolName || '未填写母校';
    if (!grouped[key]) grouped[key] = [];
    grouped[key].push(u);
  });

  return (
    <div>
      {classmates.length > 0 && (
        <div style={{ marginBottom: 16, padding: 12, background: '#fce4ec', borderRadius: 8 }}>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#e91e63', marginBottom: 6 }}>
            🏫 你的同校校友 ({classmates.length})
          </div>
          {classmates.map(u => (
            <div key={u.id} style={{ padding: '6px 0', borderBottom: '1px solid #f8bbd0', fontSize: 14 }}>
              <strong>{u.name}</strong>
              <span style={{ color: '#999', marginLeft: 8, fontSize: 13 }}>{u.className || ''} {u.headTeacher ? `· ${u.headTeacher}` : ''}</span>
            </div>
          ))}
        </div>
      )}

      {Object.entries(grouped).map(([school, list]) => (
        <div key={school} style={{ marginBottom: 16 }}>
          <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 6, color: '#333' }}>
            🏫 {school}
            <span style={{ fontWeight: 400, color: '#999', marginLeft: 6, fontSize: 13 }}>{list.length} 位校友</span>
          </div>
          {list.map((u, i) => (
            <div key={u.id || i} style={{ padding: '8px 12px', marginBottom: 4, border: '1px solid #eee', borderRadius: 8, fontSize: 14 }}>
              <div><strong>{u.name}</strong></div>
              <div style={{ fontSize: 13, color: '#666' }}>
                {u.enrollYear && u.gradYear ? `${u.enrollYear}入学 · ${u.gradYear}届` : ''} {u.className || ''}
              </div>
              {u.headTeacher && <div style={{ fontSize: 12, color: '#888' }}>班主任：{u.headTeacher}</div>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}